import { BookmarkItem } from "./BookmarkItem";

export const BookmarksPreview = () => (
  <div className="bg-primary border-primary flex h-10 flex-row items-center space-x-5 border-b px-6 py-3">
    <BookmarkItem />
    <BookmarkItem />
  </div>
);
